import { PropsWithChildren } from 'react';
import styles from './AccordionHeaderNumeric.module.scss';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';

export interface AccordionHeaderNumericProps {
  title: string;
  value: number;
}

export function AccordionHeaderNumeric({
  title,
  value,
}: PropsWithChildren<AccordionHeaderNumericProps>) {
  const { getNumberText } = useLocaleFormatter();

  return (
    <div className={styles.header}>
      <div className={styles.title}>{title}</div>
      <div className={styles.number}>{getNumberText(value)}</div>
    </div>
  );
}

export default AccordionHeaderNumeric;
